const environment = process.env.REACT_APP_ENVIRONMENT || 'production'
const configured = process.env.REACT_APP_FIREBASE_CONFIG
if (environment !== 'production' && !configured) {
    throw new Error('Explicit Firebase configuration is required outside production')
}
if (environment !== 'production' && (!process.env.REACT_APP_APP_ORIGIN || !process.env.REACT_APP_EVENT_ORIGIN || !process.env.REACT_APP_API_ORIGIN)) throw new Error('Explicit staging origins are required')
export const ENVIRONMENT = environment
export const APP_ORIGIN = process.env.REACT_APP_APP_ORIGIN || 'https://sidebarticketing.com'
export const EVENT_ORIGIN = process.env.REACT_APP_EVENT_ORIGIN || 'https://tkt.page'
export const API_ORIGIN = process.env.REACT_APP_API_ORIGIN || 'https://api.sidebarticketing.com'
export const PUBLIC_SURFACE = process.env.REACT_APP_SURFACE === 'public'
export const FIREBASE_OVERRIDE = configured ? JSON.parse(configured) : null

export const STORAGE_BUCKET = FIREBASE_OVERRIDE?.storageBucket || 'sidebar-de524.appspot.com'

export const MCP_ORIGIN = process.env.REACT_APP_MCP_ORIGIN || (environment === 'production' ? 'https://sidebar-mcp-mgj7vt5yiq-uc.a.run.app' : '')
